import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import Loadable from 'components/Loadable';

const ExpenseClaims = Loadable(lazy(() => import('./components/expense-claims/ExpenseClaims')));
const ExpenseApprovals = Loadable(lazy(() => import('./components/expense-approvals/ExpenseApprovals')));
const CompanyExpenses = Loadable(lazy(() => import('./components/company-expenses/CompanyExpenses')));

export const expenseRoutes = {
  path: 'expenses',
  children: [
    { index: true, element: <Navigate to="claims" replace /> },
    { path: 'claims', element: <ExpenseClaims /> },
    { path: 'approvals', element: <ExpenseApprovals /> },
    { path: 'company-expenses', element: <CompanyExpenses /> }
  ]
};

export default expenseRoutes;
